import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import { useChannelList } from '@/api/channel';
import { type OptionType } from '@/api/common';
import { ComboboxPickerSingle } from '@/components/Form/pickers';
import type { ComboboxProps } from '@/components/Form/pickers/primitives/combobox';

type Props = Omit<ComboboxProps<OptionType, false>, 'items' | 'filteredItems'> & {
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  onBlur?: () => void;
  onChange?: (value: OptionType | null) => void;
};

const ChannelSelect = ({
  value,
  onChange,
  disabled = false,
  size = 'large',
  className,
  placeholder = t`Select Channel...`,
  ...rest
}: Props) => {
  const { channels, isLoading } = useChannelList();
  const channelsById = useMemo(
    () => new Map((channels ?? []).map((channel) => [channel.id, channel])),
    [channels],
  );
  const resolvedValue = value ? (channelsById.get(value.id) ?? value) : null;

  return (
    <ComboboxPickerSingle<OptionType>
      items={channels}
      value={resolvedValue}
      onChange={onChange}
      disabled={disabled}
      isLoading={isLoading}
      size={size}
      className={className}
      placeholder={placeholder}
      notFoundContent={<Trans>No channels were found...</Trans>}
      {...rest}
    />
  );
};

export default ChannelSelect;
